"use client";

import Link from "@/components/link/link";
import { PAGES } from "@/configs/pages.config";
import { DEFAULT_LOCALE, SupportedLocale, withLocalePath } from "@/lib/i18n/locales";
import { getTermsCopy } from "@/lib/i18n/terms";

const TermsOfServiceContent = ({ locale }: { locale: SupportedLocale }) => {
  const copy = getTermsCopy(locale);
  const supportPath = withLocalePath(locale, PAGES.SUPPORT.PATH);

  return (
    <div className="container mx-auto max-w-3xl px-4 py-8">
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-center">{copy.title}</h1>
        <p className="text-center">{copy.effectiveDate}</p>

        {copy.sections.map(section => (
          <div key={section.title} className="space-y-2">
            <h2 className="text-xl font-bold">{section.title}</h2>
            {section.paragraphs.map((paragraph, index) => (
              <p key={`${section.title}-p-${index}`}>{paragraph}</p>
            ))}
            {section.list && (
              <ul className="list-disc space-y-2 pl-5">
                {section.list.map((item, index) => (
                  <li key={`${section.title}-li-${index}`}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}

        <p>
          {copy.contactLabel} <Link href={supportPath}>{copy.supportLinkLabel}</Link>.
        </p>
        <p>{copy.closing}</p>
      </div>
    </div>
  );
};

const TermsOfService = () => {
  return <TermsOfServiceContent locale={DEFAULT_LOCALE} />;
};

export { TermsOfServiceContent };
export default TermsOfService;
